import React, { useState, useEffect } from "react";
import Base from "../Employee_components/Employee_Base";
import { Breadcrumbs, Link, Select, MenuItem, Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import UseAxios from "../Auth/UseAxios";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";
import { ClipLoader } from "react-spinners";

const EmployeeWalletTransactionList = () => {
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState(""); // Default: Show all months
  const transactionsPerPage = 10; // Set pagination limit
  const api = UseAxios();
   const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const employeeData = JSON.parse(localStorage.getItem("employeeData"));
        const employeeReferenceId = employeeData?.employeeReferenceId;
        if (!employeeReferenceId) return;

        const response = await api.get(`${EMPLOYEE_API_BASE_URL}/employee/transactions`);
        setTransactions(response.data);
        setFilteredTransactions(response.data); // Set initial filter state
      } catch (error) {
        setError("Error fetching transactions.");
      }finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  // Filter Transactions by Selected Month
  useEffect(() => {
    if (!selectedMonth) {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions.filter((transaction) => {
        const transactionMonth = new Date(transaction.requestDate).getMonth() + 1; // Month is 0-based
        return transactionMonth === parseInt(selectedMonth);
      });
      setFilteredTransactions(filtered);
    }
    setCurrentPage(1); // Reset to first page when filtering
  }, [selectedMonth, transactions]);

  // Pagination Logic
  const indexOfLastTransaction = currentPage * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = filteredTransactions.slice(indexOfFirstTransaction, indexOfLastTransaction);

  // Get Status Color
  const getStatusColor = (status) => {
    switch (status) {
      case "APPROVED":
        return "green";
      case "REJECTED":
        return "red";
      case "PENDING":
      default:
        return "orange";
    }
  };

  return (
    <Base>
       {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
      <div className="pt-3 mt-5" style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link color="inherit" href="/employee/dashboard" sx={{ color: "blue", fontWeight: "bold" }}>
            Dashboard
          </Link>
        </Breadcrumbs>
      </div>

      {/* Title */}
      <h2 className="text-center fw-bold fs-1" style={{ color: "darkslategrey" }}>Employee Wallet Transactions</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "90%" }} />
      </div>

      {/* Month Filter Dropdown */}
      <div className="container mb-3 d-flex justify-content-end">
        <Select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          displayEmpty
          sx={{ width: "150px",height:"40px", textAlign: "center" }}
        >
          <MenuItem value="">All Months</MenuItem>
          <MenuItem value="1">January</MenuItem>
          <MenuItem value="2">February</MenuItem>
          <MenuItem value="3">March</MenuItem>
          <MenuItem value="4">April</MenuItem>
          <MenuItem value="5">May</MenuItem>
          <MenuItem value="6">June</MenuItem>
          <MenuItem value="7">July</MenuItem>
          <MenuItem value="8">August</MenuItem>
          <MenuItem value="9">September</MenuItem>
          <MenuItem value="10">October</MenuItem>
          <MenuItem value="11">November</MenuItem>
          <MenuItem value="12">December</MenuItem>
        </Select>
      </div>

      {/* Transaction Table */}
      <div className="container">
        <center>
          <table className="transcation-table table-responsive table-striped" style={{ width: "90%" }}>
            <thead>
              <tr>
                <th>Sno</th>
                <th>Date of Request</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {currentTransactions.length > 0 ? (
                currentTransactions.map((transaction, index) => (
                  <tr key={transaction.id}>
                    <td>{indexOfFirstTransaction + index + 1}</td>
                    <td>{new Date(transaction.requestDate).toLocaleDateString('en-GB')}</td>
                    <td>{transaction.withdrawAmount.toLocaleString()}</td>
                    <td style={{ color: getStatusColor(transaction.incentiveTransactionEnum), fontWeight: "bold" }}>
                      {transaction.incentiveTransactionEnum}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">No Transactions Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </center>
      </div>

      {/* Pagination Buttons */}
      <div className="d-flex justify-content-center mt-3">
        <Button
          variant="contained"
          sx={{ margin: "5px", backgroundColor: "#007bff" }}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Previous
        </Button>
        <Button
          variant="contained"
          sx={{ margin: "5px", backgroundColor: "#007bff" }}
          disabled={indexOfLastTransaction >= filteredTransactions.length}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </Button>
      </div>
      </>
      )}
    </Base>
  );
};

export default EmployeeWalletTransactionList;
